import React from 'react';
import { useParams } from 'react-router-dom';

import DeviceDetailsLayout from '@totem/components/devices/deviceDetails/DeviceDetailsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const DeviceDetailsPage = () => {
  const { id } = useParams();
  return (
    <ContentLayout>
      <IBCard isCovered>
        <DeviceDetailsLayout deviceId={id} />
      </IBCard>
    </ContentLayout>
  );
};

export default DeviceDetailsPage;
